import { render, staticRenderFns } from "./MaintenanceIndex.vue?vue&type=template&id=11715c30&"
import script from "./MaintenanceIndex.vue?vue&type=script&lang=js&"
export * from "./MaintenanceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports